import classEmptyDarkImage from 'images/class-empty-dark.png';
import classEmptyLightImage from 'images/class-empty-light.png';

const themes = {
  light: {
    themeId: 'light',
    backgroundImage: classEmptyLightImage,
    titleTextColor: 'rgba(0,0,0,0.8)',
    messageTextColor: 'rgba(0,0,0,0.7)',
  },
  dark: {
    themeId: 'dark',
    backgroundImage: classEmptyDarkImage,
    titleTextColor: 'rgba(255,255,255,0.9);',
    messageTextColor: 'rgba(255,255,255,0.8);',
  },
};

export default themes;
